import React from 'react';
import styles from '../categoryComps/editCategoryForm/addCategoryForm.module.css';

const ViewForm = ({ data, from }) => {

    return (
        <>
            <div className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>
                            {data?.category ?
                                <div>
                                    <label className={styles.addCatLabel}>Category Name*</label>
                                    <div className={styles.addCatInput}>
                                        <span style={{ fontSize: 14 }}>{data?.category?.name}</span>
                                    </div>
                                </div>
                                : null}
                            {data?.subcategory ?
                                <div >
                                    <label className={styles.addCatLabel}>Subcategory Name*</label>
                                    <div className={styles.addCatInput}>
                                        <span style={{ fontSize: 14 }}>{data?.subcategory?.name}</span>
                                    </div>
                                </div>
                                : null}
                            <div >
                                <label className={styles.addCatLabel}>{from}</label>
                                <div className={styles.addCatInput}>
                                    <span style={{ fontSize: 14 }}>{data?.name}</span>
                                </div>
                            </div>

                            
                            {from == 'Category Name*' || from == 'Manufacturer Name*' ?
                                <div className={styles.imageUpload}>
                                    <p className={styles.addCatLabel}>Cover Image</p>
                                    <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                        {data?.cover_image?.length > 0 ?
                                            <img src={data?.cover_image[0]} alt="" className={styles.previewImage} />

                                            : <div>No cover Image found</div>}

                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>

                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        {from == 'Category Name*' || from == 'Manufacturer Name*' ?
                            <>
                                <h2 className={styles.addCatH2}>Thumbnail</h2>
                                <p style={{ fontSize: '14px', color: '#777980', padding: '20px 0px 6px 0px' }}>Photo</p>
                                <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                    {data?.thumbnail?.photo?.length > 0 ?

                                        <img src={data?.thumbnail?.photo[0]} alt="" className={styles.previewImage} />
                                        :
                                        <div>
                                            No Image found
                                        </div>
                                    }

                                </div>

                            </>
                            : null}
                        <div className={styles.card} style={{ marginTop: '20px' }}>
                            <h2 className={styles.addCatH2}>Status</h2>


                            <div >
                                <label className={styles.addCatLabel}> Category Status</label>
                                <div className={styles.addCatInput}>
                                    <span style={{ fontSize: 14 }}>{data?.thumbnail?.status}</span>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </>
    );
};

export default ViewForm;
